import { AspectRatio as MantineAspectRatio, Overlay as MantineOverlay } from "@mantine/core";
import * as React from "react";

import type { ElementProps, SizeValue, StyleProps } from "./style-props";

export interface AspectRatioProps extends ElementProps<"div">, StyleProps {
  ratio: number;
  children?: React.ReactNode;
}

export const AspectRatio = React.forwardRef<HTMLDivElement, AspectRatioProps>(function AspectRatio({ children, ...props }, ref) {
  return (
    <MantineAspectRatio {...props} ref={ref}>
      {children}
    </MantineAspectRatio>
  );
});

export interface OverlayProps extends ElementProps<"div">, StyleProps {
  opacity?: number;
  color?: React.CSSProperties["backgroundColor"];
  blur?: number | string;
  gradient?: string;
  zIndex?: React.CSSProperties["zIndex"];
  radius?: SizeValue;
  children?: React.ReactNode;
  center?: boolean;
  fixed?: boolean;
}

/**
 * Mantine's Overlay is polymorphic; the wrapper deliberately fixes the default div root. Mantine 7
 * renamed the overlay's `opacity` (the backdrop color's opacity) to `backgroundOpacity` and made
 * `opacity` the element style prop; the owned `opacity` keeps its Mantine 6 meaning.
 */
const OverlayRoot = MantineOverlay as React.ComponentType<
  Omit<OverlayProps, "opacity"> & { backgroundOpacity?: number; readonly ref?: React.Ref<HTMLDivElement> }
>;

export const Overlay = React.forwardRef<HTMLDivElement, OverlayProps>(function Overlay({ children, opacity, ...props }, ref) {
  return (
    <OverlayRoot {...props} backgroundOpacity={opacity} ref={ref}>
      {children}
    </OverlayRoot>
  );
});
